import { render, staticRenderFns } from "./QualifiedDividendIncome.vue?vue&type=template&id=51cd3c6e"
import script from "./QualifiedDividendIncome.vue?vue&type=script&lang=js"
export * from "./QualifiedDividendIncome.vue?vue&type=script&lang=js"
import style0 from "./QualifiedDividendIncome.vue?vue&type=style&index=0&id=51cd3c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports